import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-provider-offers-offer',
  templateUrl: './provider-offers-offer.component.html',
  styleUrls: ['./provider-offers-offer.component.scss'],
})
export class ProviderOffersOfferComponent {
  @Input() offer: string = '';
  @Input() showMore: boolean = false;
  @Input() animalId: string | null = null;
  isExpanded: boolean = false;

  constructor(private router: Router) {}

  onShowMore() {
    if (!this.showMore) return;
    this.isExpanded = !this.isExpanded;
  }

  openAdoptionPacket(): void {
    if (!this.animalId) return;

    const url = this.router
      .createUrlTree(['/pet-folder', this.animalId])
      .toString();
    window.open(url, '_blank');
  }
}
